import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { AppHorizontalLine } from './app-horizontal-line';
import { Progress } from './app-progress';
import { withTooltip } from './app-utils';
export var AppSideBar = function (_a) {
    var sidebarItems = _a.sidebarItems, sidebarHidden = _a.sidebarHidden, progressItems = _a.progressItems, currentLocation = _a.currentLocation, onLicenceClick = _a.onLicenceClick, onTransitionEndCallback = _a.onTransitionEndCallback, isScrollable = _a.isScrollable;
    var buildSideBarLink = function (item, key, location) {
        var translateKey = item.translateKey, translateKeyOptional = item.translateKeyOptional, icon = item.icon, link = item.link, tooltipKey = item.tooltipKey;
        var translateMessage = translateKey ? React.createElement(FormattedMessage, { id: translateKey }) : null;
        var translateMessageOptional = translateKeyOptional ? React.createElement(FormattedMessage, { id: translateKeyOptional }) : null;
        var classNameLink = sidebarHidden ? 'd-flex m-auto ml-navbar' : 'd-flex m-auto w-90 ml-navbar';
        var isLinkActive = link.split('/').filter(function (v) { return v !== ''; })[0] === (location.split('/')).filter(function (v) { return v !== ''; })[0];
        var navItemStyles = "d-flex h-60px ".concat(isLinkActive ? 'nav-item-styles' : '');
        var classNameHiddenBody = sidebarHidden ? 'app-sidebar-opacity-zero' : 'app-sidebar-opacity';
        var iconComponent = (React.createElement("div", { style: { display: 'flex', width: icon.size, height: icon.size, borderRadius: icon.radius, backgroundColor: icon.color, flexShrink: 0, position: 'relative' } },
            React.createElement(FontAwesomeIcon, { icon: icon.icon, size: icon.iconSize, className: 'm-auto text-white' }),
            item.notification && withTooltip(React.createElement("div", { style: {
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: 'red',
                    position: 'absolute',
                    bottom: '-3px',
                    right: '-3px'
                } }), item.notification.text, Math.random(), 'bottom-start')));
        var messageBody = (React.createElement("div", { className: "d-flex flex-column justify-content-center ".concat(classNameHiddenBody), style: { width: sidebarHidden ? '0' : '200px', height: '48px', flexShrink: 0 } },
            React.createElement("span", { className: 'text-light ml-3 message' }, translateMessage),
            React.createElement("span", { className: 'text-muted ml-3 message-optional' }, translateMessageOptional)));
        var handleClick = function () {
            if (item.action) {
                item.action(currentLocation);
            }
        };
        var navLink = React.createElement(Link, { to: link, className: classNameLink },
            iconComponent,
            messageBody);
        var result = tooltipKey && sidebarHidden ? withTooltip(navLink, tooltipKey, tooltipKey, 'right') : navLink;
        return (React.createElement(Nav.Item, { key: key, className: navItemStyles, onClick: handleClick }, result));
    };
    var buildProgressBarItem = function (item, key) {
        return React.createElement(Progress, { key: key, hidden: sidebarHidden, now: item.now, description: item.description, className: "".concat(item.colorClass, " mt-auto mb-auto") });
    };
    var navItem = (React.createElement(Nav.Item, { className: 'd-flex' },
        React.createElement("div", { className: 'w-90 progress-title' }, progressItems.length ? React.createElement("span", null,
            React.createElement(FormattedMessage, { id: 'progress' })) : null)));
    var sidebarItemComponents = sidebarItems.map(function (item, key) { return buildSideBarLink(item, key, currentLocation); });
    var progressBarItemComponents = progressItems.map(function (item, key) { return buildProgressBarItem(item, key); });
    var progressComponents = progressItems.length !== 0 &&
        (React.createElement(Nav, { className: 'flex-column pb-3' },
            !sidebarHidden && navItem,
            progressBarItemComponents));
    var licence = (React.createElement("div", { className: 'd-flex h-60px' },
        React.createElement("div", { className: "licence ".concat(sidebarHidden ? 'd-flex m-auto' : 'd-flex m-auto w-90'), onClick: onLicenceClick },
            React.createElement(FontAwesomeIcon, { icon: faInfo, size: "1x", className: 'text-white' }),
            sidebarHidden ? null : React.createElement("span", { className: 'text-light ml-3' },
                React.createElement(FormattedMessage, { id: 'licence' })))));
    var handleOnTransitionEnd = function (event) {
        if (onTransitionEndCallback) {
            onTransitionEndCallback(event);
        }
    };
    if (isScrollable) {
        return (React.createElement("div", { className: sidebarHidden ? 'app-sidebar app-sidebar-hidden' : 'app-sidebar', onTransitionEnd: handleOnTransitionEnd },
            React.createElement(OverlayScrollbarsComponent, { style: { height: 'calc(100vh - 58px)', width: '100%' }, options: { overflowBehavior: { x: 'visible-hidden', y: 'scroll' } } },
                React.createElement("div", { className: 'd-flex flex-column justify-content-between h-100' },
                    React.createElement("div", null,
                        React.createElement(AppHorizontalLine, { className: 'mb-3' }),
                        React.createElement(Nav, { className: 'flex-column' }, sidebarItemComponents)),
                    React.createElement("div", null,
                        progressComponents,
                        React.createElement(AppHorizontalLine, null),
                        licence)))));
    }
    return (React.createElement("div", { className: sidebarHidden ? 'app-sidebar app-sidebar-hidden' : 'app-sidebar', onTransitionEnd: handleOnTransitionEnd },
        React.createElement("div", null,
            React.createElement(AppHorizontalLine, { className: 'mb-3' }),
            React.createElement(Nav, { className: 'flex-column' }, sidebarItemComponents)),
        React.createElement("div", null,
            progressComponents,
            React.createElement(AppHorizontalLine, null),
            licence)));
};
//# sourceMappingURL=app-sidebar.js.map